import { render, staticRenderFns } from "./WorkspaceInitialGraphModal.vue?vue&type=template&id=217cd63e&scoped=true"
import script from "./WorkspaceInitialGraphModal.vue?vue&type=script&lang=js"
export * from "./WorkspaceInitialGraphModal.vue?vue&type=script&lang=js"
import style0 from "./WorkspaceInitialGraphModal.vue?vue&type=style&index=0&id=217cd63e&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "217cd63e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/CFDE Knowledge - Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('217cd63e')) {
      api.createRecord('217cd63e', component.options)
    } else {
      api.reload('217cd63e', component.options)
    }
    module.hot.accept("./WorkspaceInitialGraphModal.vue?vue&type=template&id=217cd63e&scoped=true", function () {
      api.rerender('217cd63e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/customComponents/revealKgWorkspace/WorkspaceInitialGraphModal.vue"
export default component.exports